import React from "react";
import { Modal, Button, Icon } from "antd";

const ClaimBonusModal = ({ visible, onClose, onOpenLockedBalancePage, isBlocking }) => {
    return (
        <Modal
            className="custom-modal-white-bg claim-bonus-modal"
            visible={visible}
            onCancel={onClose}
            footer={null}
            centered
            title="ขอรับโบนัสสำเร็จ" // 彩金领取成功
            width={426}
            closeIcon={
                <Icon
                    type="close"
                    style={{ color: "#999999", fontSize: "14px" }}
                />
            }
        >
            <div className="claim-bonus-modal-content">
                {/* Success Icon */}
                <div className="success-icon">
                    <img src="/th/img/icon/success.svg" alt="Success" />
                </div>

                {/* Main Message */}
                <p className="main-message">
                    {/* 领取的彩金金额需要在指定时间内，完成指定流水倍数才可提款，否则将会回收此彩金。 */}
                    หากต้องการถอนยอดโบนัสที่ได้รับ
                    <br />
                    กรุณาทำยอดหมุนเวียนให้ครบภายในระยะเวลาที่กำหนด
                    <br />
                    มิฉะนั้นโบนัสจะถูกยกเลิก
                </p>

                {/* Action Buttons */}
                <div className="action-buttons">
                    {isBlocking && (
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={onOpenLockedBalancePage}
                        >
                            {/* 查看未完成流水金额 */}
                            ตรวจสอบยอดหมุนเวียนที่ยังไม่ครบ
                        </Button>
                    )}
                    <Button
                        type="primary"
                        size="large"
                        block
                        ghost={isBlocking}
                        onClick={onClose}
                    >
                        {/* 我知道了 */}
                        ตกลง
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ClaimBonusModal;
